var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _circle, _linearGradient4, _circle2, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WebAdvertising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M4,38V15h40v23c0,1.1-0.9,2-2,2H6C4.9,40,4,39.1,4,38z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "58Rnw22eNZkRSm5j_S6Eea",
    x1: 4.614,
    x2: 42.936,
    y1: 382.259,
    y2: 374.467,
    gradientTransform: "matrix(1 0 0 -1 0 390)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0077d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b59a2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#58Rnw22eNZkRSm5j_S6Eea)",
    d: "M44,10v5H4v-5c0-1.1,0.9-2,2-2h36C43.1,8,44,8.9,44,10z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "58Rnw22eNZkRSm5j_S6Eeb",
    x1: 16,
    x2: 42,
    y1: 378.5,
    y2: 378.5,
    gradientTransform: "matrix(1 0 0 -1 0 390)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7dd8f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45b0d0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#58Rnw22eNZkRSm5j_S6Eeb)",
    d: "M16.5,13h25c0.276,0,0.5-0.224,0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-25 c-0.276,0-0.5,0.224-0.5,0.5v2C16,12.776,16.224,13,16.5,13z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "58Rnw22eNZkRSm5j_S6Eec",
    x1: 6.751,
    x2: 8.032,
    y1: 379.584,
    y2: 377.731,
    gradientTransform: "matrix(1 0 0 -1 0 390)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49bef1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.5,
    r: 1.5,
    fill: "url(#58Rnw22eNZkRSm5j_S6Eec)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "58Rnw22eNZkRSm5j_S6Eed",
    x1: 11.751,
    x2: 13.032,
    y1: 379.584,
    y2: 377.731,
    gradientTransform: "matrix(1 0 0 -1 0 390)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49bef1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 11.5,
    r: 1.5,
    fill: "url(#58Rnw22eNZkRSm5j_S6Eed)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32,24.766v-4.53C32,19.003,30.997,18,29.764,18c-0.852,0-1.619,0.474-2,1.235c0,0,0,0,0,0 l-0.509,1.019l-5.702,2.851C21.214,23.275,21,23.621,21,24c0-0.552-0.448-1-1-1h-3c-1.654,0-3,1.346-3,3v2c0,1.654,1.346,3,3,3v3 c0,1.103,0.897,2,2,2s2-0.897,2-2v-4c0,0.379,0.214,0.725,0.553,0.895l5.702,2.851l0.51,1.02c0.381,0.762,1.148,1.235,2,1.235 C30.997,36,32,34.997,32,33.764v-4.532c0.626-0.562,0.998-1.373,1-2.232C33,26.141,32.627,25.329,32,24.766z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17,23.5h3.5V34c0,0.827-0.673,1.5-1.5,1.5s-1.5-0.673-1.5-1.5v-3.5H17c-1.378,0-2.5-1.122-2.5-2.5 v-2C14.5,24.622,15.622,23.5,17,23.5z M31.5,25.002v-4.766c0-0.957-0.779-1.736-1.736-1.736c-0.662,0-1.257,0.368-1.553,0.959 l-0.583,1.168L21.5,23.691v6.618l6.127,3.063l0.583,1.168c0.296,0.592,0.892,0.959,1.553,0.959c0.957,0,1.736-0.779,1.736-1.736 v-4.768c0.622-0.467,0.999-1.207,1-1.997C32.5,26.211,32.123,25.47,31.5,25.002z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.658,19.683L28,21l-6,3v6l6,3l0.658,1.317C28.868,34.735,29.296,35,29.764,35h0 C30.447,35,31,34.447,31,33.764v-5.035c0.618-0.357,0.999-1.015,1-1.729c-0.001-0.714-0.382-1.373-1-1.73v-5.033 C31,19.553,30.447,19,29.764,19h0C29.296,19,28.868,19.265,28.658,19.683z M17,24c-1.1,0-2,0.9-2,2v2c0,1.1,0.9,2,2,2h1v4 c0,0.552,0.448,1,1,1h0c0.552,0,1-0.448,1-1v-6v-4H17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WebAdvertising);
export default __webpack_public_path__ + "static/media/icons8-web-advertising.15d752281e533a1cb719a4d68fce84ab.svg";
export { ForwardRef as ReactComponent };